import type { TenantConfig } from '@/types/TenantConfig'

const red = '#ff0037'

export const japansociety: TenantConfig = {
  logo: 'assets/japansociety/static/logo-3.svg',
  themeOptions: {
    primaryColor: red,
    secondaryColor: red,
    logoHeight: '120px',
    headerBottomBorder: '1px solid #CCCCCC',
    footerBackgroundColor: 'black',
    footerTextColor: 'white',
    dialog: {
      headerIconColor: '#000000',
      headerBackground: 'url(../img/paper-texture.288c5bc0.jpg)',
      headerBorder: '1px solid var(--light-gray)',
    },
    mobileFooter: {
      cartButtonBorder: '2px solid #000000',
      cartButtonIconColor: '#000000',
      textColor: '#000000',
      priceTextColor: '#000000',
    },
  },
  teaserImageSize: {
    width: 130,
    height: 130,
  },
  componentOptions: {
    cartWidget: {
      dateTimeFormat: 'ddd, MMM D, @ h:mm A',
    },
    eventDetailRoute: {
      showVenue: true,
    },

    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/japansociety/static/completed-photo-wide.jpg',
        mobile: 'assets/japansociety/static/completed-photo-mobile.jpg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-200px',
      },
    },
  },
  i18nOverrides: {
    en: {
      homeRoute: {
        title: 'Log in, sign up or continue as a guest',
        loginTitle: 'I am a Japan Society member',
        signupTitle: 'Become a Japan Society Member',
        guestTitle: 'Checkout as a Guest',
        guestButton: 'Shop as a guest',
      },
      membership: {
        title: 'Become a Member',
        renewTitle: 'Renew Your Membership',
      },
      accountLinks: {
        registerLinkLabel: 'Membership',
      },
      checkoutRoute: {
        title: 'Pay For Your Order',
      },
      reserveDateFirst: {
        selectDateLabel: 'Choose a Date',
      },
      applyPromoCodes: {
        applyAnotherPromoCodeLabel: 'Add another discount code',
        applyPromoCodeLabel: 'Add discount code',
      },
      completedOrdersRoute: {
        title: '<span>Done!</span> We look forward to engaging with you.',
      },
    },
  },
  customContent: [
    {
      key: 'member-benefits',
      regions: ['home-member-benefits'],
      template: `
        <div>
          <p>Join our community of individuals passionate about Japan and enjoy:</p>

          <ul>
            <li>Japanese visual and performing arts</li>
            <li>Classic and contemporary film</li>
            <li>Language courses and educational workshops</li>
            <li>Timely arts, cultural and policy discussions</li>
          </ul>
        </div>
      `,
    },
    {
      key: 'guest-shopping',
      regions: ['home-guest-experience'],
      template: `
        <p>You can shop as a guest without having to register.</p>
      `,
    },
    {
      // TODO Move to completedOrdersRoute.title i18n string. (No other tenants use this tenant content region.)
      key: 'completed-before-tickets',
      regions: ['completed-before-tickets'],
      template: `
        <div>
          Thank you for your patronage. ご利用ありがとうございました。
        </div>
      `,
    },
    {
      key: 'resend-tickets',
      regions: ['below-content'],
      enabledRoutes: ['home'],
      template: `
        <div>
          <p>
            Already have a ticket?
          </p>

          <p>
            <router-link :to="{ name: 'resend' }">
              Resend ticket confirmation
            </router-link>
          </p>
        </div>
      `,
    },
  ],
}
